import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Item, ItemIndicator, ItemText } from '@radix-ui/react-select';
import { cn } from 'cn';

interface SelectItemProps extends React.ComponentPropsWithoutRef<typeof Item> {
  showIndicator?: boolean;
  endAdornment?: React.ReactNode;
  subtitle?: React.ReactNode;
  ref?: React.Ref<React.ElementRef<typeof Item>>;
}

/**
 * @deprecated Use `SelectItem` from `@/ui` for new work — the Radix-free,
 * shadcn-sourced design system. See `.agents/rules/project.md` →
 * "Shared Library Reuse". Kept for existing call sites; do not use in new UI.
 */
function SelectItem({
  className,
  children,
  showIndicator,
  endAdornment,
  subtitle,
  ref,
  ...props
}: SelectItemProps) {
  return (
    <Item
      data-test='select-item'
      ref={ref}
      className={cn(
        'relative flex w-full cursor-default items-center rounded-lg px-3 py-2 text-sm outline-hidden select-none focus:bg-gray-100 focus:text-gray-700 focus-visible:z-10 data-disabled:pointer-events-none data-disabled:opacity-50 data-[state=checked]:bg-gray-50 data-[state=checked]:focus:bg-gray-100',
        showIndicator && 'pl-8',
        subtitle && 'flex-col items-start gap-1',
        className
      )}
      {...props}
    >
      {showIndicator ? (
        <span className='absolute left-2 flex size-3.5 items-center justify-center'>
          <ItemIndicator>
            <FontAwesomeIcon icon={faCheck} className='size-4' />
          </ItemIndicator>
        </span>
      ) : null}

      <ItemText>{children}</ItemText>
      {subtitle ? (
        <span className='text-xs/4 text-gray-600'>{subtitle}</span>
      ) : null}
      {endAdornment !== undefined && endAdornment !== null ? (
        <span className='absolute right-2 flex size-3.5 items-center justify-center text-gray-500'>
          {endAdornment}
        </span>
      ) : null}
    </Item>
  );
}

export default SelectItem;
